module.exports = __webpack_public_path__ + "static/img/lock2.16a4a0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lock2.png
// module id = FW1q
// module chunks = 128